export const enableContentSharingKey = 'ENABLE_CONTENT_SHARING';
export const enableTenantManagementKey = 'ENABLE_TENANT_MANAGEMENT';
export const advancedCompanySettingsKey = 'ADVANCED_COMPANY_SETTINGS';
export const officeEmailParametersKey = 'OFFICE365_EMAIL_PARAMETERS';
export const notificationTeamsCredentialKey =
  'NOTIFICATION_TEAMS_CREDENTIALS_ID';
export const notificationVoiceCallCredentialKey =
  'NOTIFICATION_VOICE_CALL_CREDENTIALS_ID';
export const entraIdCredentialKey = 'ENTRAID_USER_PROFILE_CREDENTIALS_ID';
export const useParentAssignedRolesKey = 'USE_PARENT_ASSIGNED_ROLES';
export const mfaEmailRequiredKey = 'MFA_EMAIL_REQUIRED';

export const moduleOnLoadKeys = [
  enableContentSharingKey,
  advancedCompanySettingsKey,
  enableTenantManagementKey
];
